export type PublicationStatus = 'draft' | 'published' | 'closed' | 'archived'

export type LifecycleAction = 'publish' | 'unpublish' | 'close' | 'archive' | 'restore'

export const LIFECYCLE_ACTION_LABELS: Record<LifecycleAction, string> = {
  publish: 'Publish',
  unpublish: 'Unpublish',
  close: 'Close',
  archive: 'Archive',
  restore: 'Restore',
}

export function lifecyclePrimaryAction(status: PublicationStatus | undefined): LifecycleAction | null {
  switch (status) {
    case 'draft':
      return 'publish'
    case 'published':
      return 'unpublish'
    case 'closed':
      return 'publish'
    case 'archived':
      return 'restore'
    default:
      return null
  }
}

export function lifecyclePrimaryLabel(
  status: PublicationStatus | undefined,
  action: LifecycleAction,
): string {
  if (status === 'closed' && action === 'publish') {
    return 'Re-open'
  }
  return LIFECYCLE_ACTION_LABELS[action]
}

export function lifecycleInviteAvailable(status: PublicationStatus | undefined): boolean {
  return status === 'published'
}

export function lifecycleShowsDelete(status: PublicationStatus | undefined): boolean {
  return status === 'draft'
}

export function lifecycleDropdownActions(status: PublicationStatus | undefined): LifecycleAction[] {
  switch (status) {
    case 'draft':
      return ['archive']
    case 'published':
      return ['close', 'archive']
    case 'closed':
      return ['archive']
    default:
      return []
  }
}

export function lifecycleActionNeedsConfirm(action: LifecycleAction): boolean {
  return action === 'close' || action === 'archive'
}

export function lifecycleConfirmCopy(action: LifecycleAction): { title: string; description: string } {
  if (action === 'close') {
    return {
      title: 'Close this job?',
      description:
        'The job will be removed from the job board. Applicant tracking is kept and you can re-open later.',
    }
  }
  return {
    title: 'Archive this job?',
    description:
      'The job will be hidden from your active list. You can restore it to draft later.',
  }
}

export function lifecycleSuccessMessage(action: LifecycleAction): string {
  switch (action) {
    case 'publish':
      return 'Job published.'
    case 'unpublish':
      return 'Job unpublished.'
    case 'close':
      return 'Job closed.'
    case 'archive':
      return 'Job archived.'
    case 'restore':
      return 'Job restored to draft.'
    default:
      return 'Job updated.'
  }
}
